import React from 'react';
import { useField } from 'formik';
import { PatternFormat } from 'react-number-format';
import { TextField, InputAdornment } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ContactlessIcon from '@mui/icons-material/Contactless'; // Example for Amex

import VisaIcon from '../../images/cc/Visa';
import MastercardIcon from '../../images/cc/Mastercard';
import AmexIcon from '../../images/cc/Amex';

const getCardIcon = (cardNumber) => {
  if (!cardNumber) return <CreditCardIcon />;

  // Strip non-digits just in case
  const digits = cardNumber.replace(/\D/g, '');

  // 1. Visa: Starts with 4
  if (/^4/.test(digits)) {
    return <VisaIcon style={{ width: 34 }} />;
  }

  // 2. Amex: Starts with 34 or 37
  if (/^3[47]/.test(digits)) {
    return <AmexIcon style={{ width: 34 }} />;
  }

  // 3. Mastercard: Starts with 51-55 or 2221-2720
  if (/^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)/.test(digits)) {
    return <MastercardIcon style={{ width: 34 }} />;
  }

  // Default: Generic MUI Icon
  return <CreditCardIcon />;
};

const CreditCardField = ({ label, placeholder, size = "small", ...props }) => {
  const [field, meta, helpers] = useField(props.name);

  const { value } = field;
  const CurrentIcon = getCardIcon(value);

  // Identify card type
  const isAmex = value?.startsWith('34') || value?.startsWith('37');
  const cardFormat = isAmex ? "#### ###### #####" : "#### #### #### ####";

  return (
    <PatternFormat
      {...props}
      {...field}
      format={cardFormat}
      // mask="_"
      customInput={TextField}
      fullWidth
      placeholder={placeholder}
      // label={label}
      size={size}
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error}
      onChange={() => {}}
      onValueChange={(values) => {
        helpers.setValue(values.value); // Sync raw digits to Formik
      }}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end" sx={{ mr: 1 }}>
              {CurrentIcon}
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default CreditCardField;